// Override default sorting for /collections/all page
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the collections/all page
  if (window.location.pathname === '/collections/all') {
    
    // Find all sorting dropdowns
    const sortSelects = document.querySelectorAll('select[name="sort_by"]');
    
    sortSelects.forEach(function(select) {
      // If no sort parameter in URL, default to best-selling
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('sort_by')) {
        // Change the selection to best-selling
        select.value = 'best-selling';
        
        // Update URL and reload with best-selling
        const newUrl = window.location.pathname + '?sort_by=best-selling';
        window.location.href = newUrl;
      }
    });
  }
});
